/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Lean_GizlilikInputs */

const tr_footer_lean_gizlilik = /** @type {(inputs: Footer_Lean_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik`)
};

const en_footer_lean_gizlilik = /** @type {(inputs: Footer_Lean_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

const de_footer_lean_gizlilik = /** @type {(inputs: Footer_Lean_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutz`)
};

const ru_footer_lean_gizlilik = /** @type {(inputs: Footer_Lean_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конфиденциальность`)
};

/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Footer_Lean_GizlilikInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const footer_lean_gizlilik = /** @type {((inputs?: Footer_Lean_GizlilikInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Lean_GizlilikInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_lean_gizlilik(inputs)
	if (locale === "de") return de_footer_lean_gizlilik(inputs)
	if (locale === "ru") return ru_footer_lean_gizlilik(inputs)
	return tr_footer_lean_gizlilik(inputs)
});